import { defineComponent, reactive, computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import _ from 'lodash';
import { SettingTable, SettingTableRow, BaseSlider, Tooltip } from '@hems/component';
import { Helper } from '@hems/util';
export default defineComponent({
    name: 'EnergyBackupSettingPvModuleGen2',
    components: {
        SettingTable,
        SettingTableRow,
        BaseSlider,
        Tooltip,
    },
    props: {
        modelValue: {
            type: Object,
            default: () => ({ backup_soc: 0 }),
        },
        editable: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:modelValue'],
    async setup(props, { emit }) {
        const { t } = useI18n();
        const store = useStore();
        const state = reactive({
            data: { ...props.modelValue },
            show: true,
            deviceId: store.state.user.ownDeviceId,
        });
        const description = computed(() => `${valueRange.backup_soc.min} ~ ${valueRange.backup_soc.max} %, ${t('message.5_per_incre')}`);
        const valueRange = {
            backup_soc: { min: 0, max: 100 },
        };
        watch(() => state.data.backup_soc, () => {
            emit('update:modelValue', _.pickBy(state.data, (v) => !Helper.isNull(v)));
        });
        return {
            state,
            valueRange,
            description,
        };
    },
});
